// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__25w17","info":"Note_info__3YArL","note":"Note_note__1zjoI","actions":"Note_actions__g-1-d"};